import React from 'react';
import './CTASection.css';

const CTASection = () => {
  return (
    <section className="cta-section">
      <div className="cta-container">
        <h2 className="cta-title">Ready to supercharge your sales with Amenity Scores?</h2>
        <p className="cta-description">
          Discover London neighborhoods with the amenities that matter most to you.
        </p>
        <a href="#" className="cta-button">
          Get Started Today
        </a>
      </div>
    </section>
  );
};

export default CTASection;